
import { VizPortalWebClientRequester, WebClientResponseHelper } from '@tableau/vizportal-webclient-api';
import {
  GetViewByPathMethod,
  IGetViewByPathParams,
  IGetViewByPathResult
} from '@tableau/vizportal-webclient-api/lib/api/methods/GetViewByPathMethod';
import React from 'react';
import { Logger } from '../../../data-catalog-shared';

/**
 * A wrapper around the Sparkline component that makes the API query to populate its data.
 */
export class SparklineQueryWrapper extends React.Component<
  SparklineQueryWrapperProps, SparklineQueryWrapperState> {

  public constructor(props: SparklineQueryWrapperProps) {
    super(props);
    this.state = {
      dataPoints: []
    };
  }

  private async sendRequest(vizPortalWebClientRequester: VizPortalWebClientRequester): Promise<IGetViewByPathResult | null> {
    const get = vizPortalWebClientRequester.createSender(GetViewByPathMethod);
    const params: IGetViewByPathParams = { path: this.props.viewPath };
    const resp = await get(params);
    if (!WebClientResponseHelper.isErrorResponse(resp)) {
      return resp.response.result as IGetViewByPathResult;
    }
    return null;
  }

  public override componentDidMount() {
    this.sendRequest(this.props.vizPortalWebClientRequester).then(viewDetails => {
      const dataPointsArray = viewDetails && viewDetails.hitsTimeSeries || [];
      this.setState({
        dataPoints: dataPointsArray as ReadonlyArray<number>
      });
    }).catch(err => {
      Logger.error(`getViewByPath for Sparkline did not succeed. The sparkline will be unavailable. ${String(err)}`);
    });
  }

  public override render(): React.ReactElement<React.DOMAttributes<HTMLDivElement>> {
    return this.props.children({ dataPoints: this.state.dataPoints });
  }
}

export interface SparklineQueryWrapperProps {
  readonly vizPortalWebClientRequester: VizPortalWebClientRequester;
  readonly viewPath: string;
  readonly children: (props: SparklineQueryWrapperChildProps) => JSX.Element;
}

export interface SparklineQueryWrapperChildProps {
  readonly dataPoints: ReadonlyArray<number>;
}

interface SparklineQueryWrapperState {
  readonly dataPoints: ReadonlyArray<number>;
}
